export interface IPoint {
  x: number;
  y: number;
}

export interface INormalizedRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * Ограничить значение отрезком [0, 1]
 * @param value - доля от размера скриншота
 */
const clampFraction = (value: number) => Math.min(Math.max(value, 0), 1);

/**
 * Построить нормализованную рамку по двум точкам.
 * Координаты хранятся долями от размеров скриншота: рамка не «уезжает»
 * при другом масштабе превью и при запекании в полноразмерный canvas.
 * @param start - точка начала перетаскивания в координатах скриншота
 * @param end - точка окончания перетаскивания в координатах скриншота
 * @param canvasWidth - ширина скриншота в пикселях
 * @param canvasHeight - высота скриншота в пикселях
 */
export const pointsToRect = (
  start: IPoint,
  end: IPoint,
  canvasWidth: number,
  canvasHeight: number
): INormalizedRect => {
  const left = clampFraction(Math.min(start.x, end.x) / canvasWidth);
  const right = clampFraction(Math.max(start.x, end.x) / canvasWidth);
  const top = clampFraction(Math.min(start.y, end.y) / canvasHeight);
  const bottom = clampFraction(Math.max(start.y, end.y) / canvasHeight);

  return { height: bottom - top, width: right - left, x: left, y: top };
};

/**
 * Перевести нормализованную рамку в пиксели заданного canvas
 * @param rect - рамка в долях от размеров скриншота
 * @param width - ширина целевого canvas в пикселях
 * @param height - высота целевого canvas в пикселях
 */
export const denormalizeRect = (
  rect: INormalizedRect,
  width: number,
  height: number
) => ({
  height: rect.height * height,
  width: rect.width * width,
  x: rect.x * width,
  y: rect.y * height
});
